import script from "./BatchDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./BatchDetailPage.vue?vue&type=style&index=0&id=83d48f76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83d48f76"]])

export default __exports__